import React, { useState } from 'react';
import { useSurvey } from './Context';

import AccordionPanel from './AccordionPanel';


function AppQuestions() {
    const [openPanelIndex, setOpenPanelIndex] = useState(0);

    const handlePanelToggle = (panelIndex) => {
        setOpenPanelIndex(openPanelIndex === panelIndex ? -1 : panelIndex);
    };

    const { topics } = useSurvey();

    return (
        <div className="questions-accordion">
            {topics.map((panel, index) => (
                <AccordionPanel
                    key={index}
                    data={panel}
                    // title={panel.title}
                    // questions={panel.questions}
                    isOpen={openPanelIndex === index}
                    onToggle={() => handlePanelToggle(index)}
                />
            ))}
        </div>
    );
}

export default AppQuestions;
